import React, { useState, useContext } from "react";
import { ContextProvider } from "../../App"
import { useHistory, useLocation, useParams}  from "react-router-dom"

import styles from "./authorizedHeader.module.css";
import Logo from "../../images/logo.svg";
import DownArrow from "../../images/downArrow.svg";

import MenuIconBlack from "../../images/menuIconBlack.svg";
import MenuIcon from "../../images/headerMenu.svg";
import ActiveMenuIcon from "../../images/activeMenu.svg";
import ActiveMenuIconOrange from "../../images/activeMenuOrange.svg";
import DropDownMenu from "./DropDownMenu";


function AuthorizedHeader() {
  const { pathname } = useLocation();
  const { id } = useParams();
  const [openDropdown, setOpenDropdown] = useState(false);
  const { authState } = useContext(ContextProvider)
  const history = useHistory();

  const handleMenu = () => {
      history.push("/food/categories")
  };
  const handleActiveMenu = () => {
      history.push("/food/order-summery")
  };
  const goToHome = () => {
    history.push("/")
  }

  return (
    <>          
          <div className={styles.auth_header_wrapper}>
              <div className={styles.auth_header_container}>
          <div className={styles.auth_header_logo_box}>
            <img src={Logo} alt="logo" className={styles.header_logo_img} onClick={ goToHome}/>
            <div className={styles.zip_box}>
              <span>{ authState.loggedInUser.user.zipCode}</span>      
            </div>
          </div>
          <div className={styles.auth_header_items_box}>
            <ul className={styles.auth_header_ul}>
              <li
                className={styles.auth_header_items}
                onClick={() => handleMenu("/food/categories")}
              >
                <img src={pathname === "/food/categories" || pathname === "/food/order/selections-plan" ? MenuIcon : MenuIconBlack} alt="logo" />
                <span style={{ color: pathname === "/food/categories" || pathname === "/food/order/selections-plan" ? "#FBA922" : "#000" }}>
                  Menu
                </span>
              </li>

              <li
                className={styles.auth_header_items}
                onClick={() => handleActiveMenu("/food/order-summery")}
              >
                <img
                  src={pathname === "/food/order-summery" || pathname === `/food/order-summery/${id}` ? ActiveMenuIconOrange : ActiveMenuIcon}
                  alt="logo"
                />
                <span style={{ color: pathname === "/food/order-summery" || pathname === `/food/order-summery/${id}` ? "#FBA922" : "#000" }}>
                  Active Menu
                </span>
              </li>
              <li className={styles.auth_header_items} onClick={ ()=>setOpenDropdown(!openDropdown)}>
                <span>{ authState.loggedInUser.user.name}</span>
                <img src={DownArrow} alt="logo" />
              </li>
            </ul>
            {
              openDropdown && <DropDownMenu email={authState.loggedInUser.user.email} mobile={authState.loggedInUser.user.mobile }/>
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default AuthorizedHeader;
